import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

export function CreditsWallet({ user, credits, onOpen }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!user) return setVisible(false);
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [user]);

  return (
    <AnimatePresence>
      {user && visible && (
        <motion.button
          key="wallet"
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          onClick={onOpen}
          className="fixed bottom-5 right-5 z-40 glass rounded-full pl-3 pr-4 py-2.5 flex items-center gap-2.5 hover:border-[rgb(var(--brand))]/60 border transition-colors group"
          data-testid="floating-wallet"
          title="Ver planes de créditos"
        >
          <span className="relative flex h-2 w-2">
            <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${credits === null ? "bg-red-400" : "bg-[rgb(var(--brand))]"} opacity-70`} />
            <span className={`relative inline-flex h-2 w-2 rounded-full ${credits === null ? "bg-red-400" : "bg-[rgb(var(--brand))]"}`} />
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[rgb(var(--paper-dim))]">créditos</span>
          {credits === null ? (
            <span className="font-display italic text-lg text-red-400 leading-none" data-testid="wallet-error">Error</span>
          ) : (
            <span className="font-display italic text-lg text-[rgb(var(--paper))] leading-none">
              {credits.toLocaleString("es-ES")}
            </span>
          )}
          <span className="opacity-40 group-hover:opacity-100 transition-opacity text-[rgb(var(--paper-dim))] text-xs">↗</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
